enum AuthErrors {
    INITIALIZATION_FAILED = 'authInitializationFailed',
}

export default AuthErrors;
